import { Bot, User2 } from "lucide-react";

import { cn, formatDate } from "@/lib/utils";

interface AgentMessageProps {
  role: "user" | "assistant";
  content: string;
  createdAt: string;
}

export function AgentMessage({ role, content, createdAt }: AgentMessageProps) {
  const isUser = role === "user";
  const Icon = isUser ? User2 : Bot;

  return (
    <div className={cn("flex gap-3", isUser && "justify-end")}>
      {!isUser ? (
        <div className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-accent-subtle text-accent">
          <Icon className="h-4 w-4" />
        </div>
      ) : null}
      <div
        className={cn(
          "max-w-[88%] rounded-3xl border border-border/70 px-4 py-3 shadow-sm",
          isUser
            ? "bg-accent text-white"
            : "bg-background-elevated/90 text-text-primary",
        )}
      >
        <p className="whitespace-pre-wrap text-sm leading-6">{content}</p>
        <p className={cn("mt-2 text-[11px]", isUser ? "text-white/80" : "text-text-tertiary")}>
          {formatDate(createdAt, "MMM d, HH:mm")}
        </p>
      </div>
      {isUser ? (
        <div className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-background-secondary text-text-secondary">
          <Icon className="h-4 w-4" />
        </div>
      ) : null}
    </div>
  );
}
